import React from 'react';
import InfoPageLayout from './InfoPageLayout';

export default function AboutPage() {
  return (
    <InfoPageLayout
      title="About | Lilycove"
      description="Learn what Lilycove is building for Pokemon card collectors."
      heading="About"
      body="Lilycove helps Pokemon card collectors search and compare listings from major marketplaces in one place. We focus on transparent pricing, cleaner discovery, and tools that make collecting easier."
    />
  );
}
